lmApp
/**
 * [NG-CONTROLLER]
 */
  .controller('DropdownController', ['$scope', '$document', '$window', 'KeyService',
    function ($scope, $document, $window, KeyService) {

      /**
       * [EVENT HANDLER] Keyboard action
       * @param event
       * @private
       */
      $scope._OnKeyDown = function (event) {
        if (event.which == KeyService.Keys.ESCAPE) {
          if (event.preventDefault) event.preventDefault();
          if (event.stopPropagation) event.stopPropagation();
          $scope._CloseDropdown();
        }
      };

      /**
       * [DOM] Open dropdown: show with animation;
       * @private
       */
      $scope._OpenDropdown = function (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        $document.bind('keydown', $scope._OnKeyDown);
        $scope._empty_.appendTo('body');
        $scope._ChangePosition();
        $scope._dropmenu_.css({display: 'block'});

        if (!$scope.width) {
          $scope._dropmenu_.css({width: $scope._toogle_.outerWidth()});
        }

        TweenMax.from($scope._dropmenu_, 0.35, {
          height: 0,
          ease: Expo.easeInOut,
          onComplete: function () {
            $scope._dropmenu_.css({'overflow-y': 'auto'});
            var bodyHeight = $document[0].documentElement.clientHeight;
            var optionsHeight = $scope._dropmenu_.height();
            var optionsOffsetTop = $scope._dropmenu_.offset().top - $document.scrollTop();
            var bodyScrollTop = angular.element('body').scrollTop();

            if (optionsHeight + optionsOffsetTop > bodyHeight) {
              $scope._dropmenu_.css({height: bodyHeight - optionsOffsetTop + bodyScrollTop - 10});
            }
            $document.bind('click', $scope._CloseDropdown);
            $document.bind('keydown', $scope._OnKeyDown);
          }
        });

        $scope._dropmenu_.bind('keydown', $scope._OnKeyDown);
        angular.element($scope._container_).bind('resize', $scope._ChangePosition);
        angular.element($scope._container_).bind('resize', $scope._ChangeSize);
        angular.element($scope._container_).bind('scroll', $scope._ChangePosition);
      };

      $scope._ChangePosition = function () {
        $scope._dropmenu_.css({
          overflow: 'hidden',
          top: $scope._toogle_.offset().top - $document.scrollTop(),
          left: $scope._toogle_.offset().left - $document.scrollLeft()
        });
      };

      $scope._ChangeSize = function () {
        $scope._dropmenu_.css({width: $scope._toogle_.outerWidth()});

        var bodyHeight = $document[0].documentElement.clientHeight;
        var optionsHeight = $scope._dropmenu_.height();
        var optionsOffsetTop = $scope._dropmenu_.offset().top - $document.scrollTop();
        var bodyScrollTop = angular.element('body').scrollTop();

        if (optionsHeight + optionsOffsetTop > bodyHeight) {
          $scope._dropmenu_.css({height: bodyHeight - optionsOffsetTop + bodyScrollTop - 10});
        }
      };

      /**
       * [DOM] Close dropdown: hide with animation
       * @private
       */
      $scope._CloseDropdown = function () {
        $document.unbind('keydown', $scope._OnKeyDown);
        $scope._dropmenu_.css({overflow: 'hidden'});

        TweenMax.to($scope._dropmenu_, 0.35, {
          height: 0,
          display: 'none',
          ease: Expo.easeInOut,
          onComplete: function () {
            $scope._dropmenu_.css({'overflow-y': 'auto'});
            $scope._empty_.remove();
          },
          clearProps: 'height,width'
        });

        $document.unbind('click', $scope._CloseDropdown);
        $document.unbind('keydown', $scope._CloseDropdown);
        angular.element($scope._container_).unbind('resize', $scope._ChangePosition);
        angular.element($scope._container_).unbind('resize', $scope._ChangeSize);
        angular.element($scope._container_).unbind('scroll', $scope._ChangePosition);
      };
    }])
  /**
   * [NG-DIRECTIVE] Replace element with empty DIVs for transclude
   */
  .directive('lmDropdown', ['$window',
    function ($window) {
      return {
        restrict: 'E',
        templateUrl: 'lm-dropdown/lm-dropdown.tpl.html',
        controller: 'DropdownController',
        transclude: {
          toggle: 'lmDropdownToogle',
          menu: 'lmDropdownMenu'
        },
        scope: true,
        replace: true,
        link: function (scope, element, attrs) {
          scope.width = !!attrs.width;

          scope._container_ = attrs.container ? angular.element(attrs.container) : $window;
          scope._toogle_ = element.find('#toggle');
          scope._dropmenu_ = element.find('#dropdown');

          scope._dropmenu_.appendTo('body');
          scope._empty_ = angular.element('<div id="empty" style="opacity: 0.6; height: 400%; z-index: 9999;"></div>');
          scope._empty_.css({'z-index': +scope._dropmenu_.css('z-index') - 1});

          scope.$on('$destroy', function () {
            scope._dropmenu_ && scope._dropmenu_.remove();
          });

          element.bind('keydown', scope._OnKeyDown);
          //element.on('$destroy', function () {});
        }
      };
    }]);
